
import { defineComponent } from 'vue'
// import SlideButton from './SlideButton.vue'
import { useGlobalStore } from '@/stores/globalStore'

export default defineComponent({
  components: {
    // SlideButton,
  },
  setup() {
    const globalStore = useGlobalStore()
    const setViewModeClass = () => {
      const htmlTag = window.document.getElementsByTagName('html')[0]
      const viewmodeClassName = 'viewmode-light'

      htmlTag.classList.remove('viewmode-dark')
      htmlTag.classList.remove('viewmode-light')
      htmlTag.classList.add(viewmodeClassName)
    }
    setViewModeClass()

    return {
      globalStore,
    }
  },
})
